// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.question {
  padding: 0 15px 0 15px;
}
.question p {
  opacity: 0.65;
  font-weight: 700;
  padding-bottom: 4px;
}
.question .buttonCombo {
  width: 100%;
}
.question .buttonCombo .leftButton,
.question .buttonCombo .rightButton,
.question .buttonCombo .middleButton {
  border: 1px solid #a8b7c7;
  height: 38px;
  max-height: 38px;
  display: inline-block;
  background-color: #fff;
  color: #262626;
  margin: 0;
}
.question .buttonCombo .leftButton.selected,
.question .buttonCombo .rightButton.selected {
  opacity: 1;
  font-weight: 700;
}
.question .buttonCombo .leftButton {
  border-radius: 8px 0 0 8px;
}
.question .buttonCombo .rightButton {
  border-radius: 0 8px 8px 0;
}
.question .buttonCombo .middleButton {
  border-radius: 0;
}
@media (max-width: 846px) {
  .question {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/Question.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EACC,sBAAA;AAYD;AAbA;EAIE,aAAA;EACA,gBAAA;EACA,mBAAA;AAYF;AAlBA;EAUE,WAAA;AAWF;AArBA;;;EAcG,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAYH;AAhCA;;EAyBG,UAAA;EACA,gBAAA;AAWH;AArCA;EA8BG,0BAAA;AAUH;AAxCA;EAkCG,0BAAA;AASH;AA3CA;EAsCG,gBAAA;AAQH;AAJC;EAAA;IACC,UAAA;EAOA;AACF","sourcesContent":["@import '../../constants.less';\n\n.question {\n\tpadding: 0 15px 0 15px;\n\n\tp {\n\t\topacity: 0.65;\n\t\tfont-weight: @sofiaFontBold;\n\t\tpadding-bottom: 4px;\n\t}\n\n\t.buttonCombo {\n\t\twidth: 100%;\n\t\t.leftButton,\n\t\t.rightButton,\n\t\t.middleButton {\n\t\t\tborder: 1px solid @blueyGrey;\n\t\t\theight: 38px;\n\t\t\tmax-height: 38px;\n\t\t\tdisplay: inline-block;\n\t\t\tbackground-color: @white;\n\t\t\tcolor: @grey26;\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t.leftButton.selected,\n\t\t.rightButton.selected {\n\t\t\topacity: 1;\n\t\t\tfont-weight: @sofiaFontBold;\n\t\t}\n\n\t\t.leftButton {\n\t\t\tborder-radius: 8px 0 0 8px;\n\t\t}\n\n\t\t.rightButton {\n\t\t\tborder-radius: 0 8px 8px 0;\n\t\t}\n\n\t\t.middleButton { \n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t@media (max-width: @dataCaptureTwoColumnFieldsPageMinWidth) {\n\t\tpadding: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
